export default __webpack_public_path__ + "static/media/analytics.3df6f0a4.png";